(function() {
	let commonAction = function() {
		if(commonAction.executed) {
			return;
		}
		commonAction.executed = true

		const mediaQuery = window.matchMedia('(max-width: 767px)'); // メディアクエリを登録

		const lp_anchor = document.querySelector('#lp-nav:not(.is-open)'); //アンカーナビ

		// LPヘッダー各リンク
		const lp_header = document.querySelector('.lp-header:not(.is-active)');
		const lp_header_trigger =  document.querySelector('.lp-mv');
		const controller = new ScrollMagic.Controller();
		let scene_01 = new ScrollMagic.Scene({
		triggerElement: lp_header_trigger,// トリガー
		triggerHook: 'onLeave',// トリガーが見えなくなったら
		reverse: true,// 逆スクロールに対応
		offset: 400 //
		})
		controller.addScene([
			scene_01
		]);
		// .addTo(controller);
		scene_01.on('progress', ()=>{
			if(!lp_header.classList.contains("is-active")) {
				lp_header.classList.add('is-active');// classを追加
				lp_header.classList.remove('none-active');
			} else if(lp_header.classList.contains("is-active")) {
				lp_header.classList.remove('is-active');
				lp_header.classList.add('none-active');// classを追加
			}
		})


		// アンカーリンク出現(PC)
		const lp_anchor_trigger =  document.querySelector('.lp-anchor');
		let lp_anchor_height = lp_anchor_trigger.clientHeight;

		let scene_02 = new ScrollMagic.Scene({
			triggerElement: lp_anchor_trigger,// トリガー
			triggerHook: 'onLeave',// トリガーが見えなくなったら
			reverse: true,// 逆スクロールに対応
			offset: lp_anchor_height - 135 // triggerから400pxスクロールしたら
		})
		controller.addScene([
			scene_02
		]);
		// .addTo(controller);
		scene_02.on('progress', ()=>{
			if (mediaQuery.matches) {
				scene_02.destroy();
			} else {
				if(!lp_anchor.classList.contains("is-open")) {
					lp_anchor.classList.add('is-open');// classを追加
				} else if(lp_anchor.classList.contains("is-open")) {
					lp_anchor.classList.remove('is-open');
				}
			}
		})
		window.onload = scene_02;
		window.onresize = scene_02;


		// アンカーリンク出現(SP)
		const lp_anchor_btn = document.querySelector('.openbtn'); //アンカーオープンボタン
		const nav_bg = document.querySelector('.nav-bg'); //SPアンカー出現時背景

		lp_anchor_btn.addEventListener('click', (e) => {
			e.stopPropagation();
			if(!lp_anchor.classList.contains("is-open")) {
				lp_anchor.classList.add('is-open');// classを追加
				lp_anchor_btn.classList.add('is-open');// classを追加
				nav_bg.classList.add('is-open');// classを追加
				bodyScrollLock.disableBodyScroll(lp_anchor);
			} else {
				lp_anchor.classList.remove('is-open');
				lp_anchor_btn.classList.remove('is-open');
				nav_bg.classList.remove('is-open');
				bodyScrollLock.clearAllBodyScrollLocks();
			}
		});


		// アンカーリンク移動時（メニュークリック時）
		const jsSmoothScroll = document.querySelectorAll('.sneaker-shop a[href^="#"]');
		const nav_items = document.querySelectorAll('.nav-inner .item');

		for (let i = 0; i < jsSmoothScroll.length; i++){
			let href = jsSmoothScroll[i].getAttribute('href');
			let anchor_link_target = document.getElementById(href.replace('#', ''));

			jsSmoothScroll[i].addEventListener('click', (e) => {
				// クリックされたときのデフォルトの挙動を防ぐ
				e.preventDefault();
				//取得した要素の位置を取得するために、getBoundingClientRect()を呼び出し、ページ上の位置を計算。
				const rect = anchor_link_target.getBoundingClientRect().top - 99;
				const offset = window.pageYOffset;
				// 移動先のポジション取得
				const position = rect + offset;
				// window.scrollToでスクロール
				window.scrollTo({
					top: position,
					behavior: 'smooth',
				});

				let nav_target = e.target.closest('.item');

				if (mediaQuery.matches) {
					// SPの時
					// ナビ閉じる
				    if(lp_anchor.classList.contains("is-open")) {
						// console.log('ok');
						lp_anchor.classList.remove('is-open');
						lp_anchor_btn.classList.remove('is-open');
						nav_bg.classList.remove('is-open');
						bodyScrollLock.clearAllBodyScrollLocks();
					}
				}
			});
		}


		const contents = document.querySelectorAll('.section .contents');
		let naviItem_links = document.querySelectorAll('#lp-nav .nav-inner .item');
		// const lp_header
		window.addEventListener('scroll', (event) => {
			let header_bottom = lp_header.getBoundingClientRect().top + lp_header.clientHeight;
			let now_ancher = null;
			for (let i = 0; i < contents.length; i++){
				let content = contents[i];
				let id = content.id;
				if(id){
					let top = content.getBoundingClientRect().top;
					if(top < header_bottom){
						let naviItem_link = document.querySelector(`#lp-nav .nav-inner .item a[href="#${id}"]`);
						// console.log(naviItem_link);
						if(naviItem_link) {
							now_ancher = naviItem_link.parentNode;
						}
					}
				}

			}
			naviItem_links.forEach((item) => {
				item.classList.remove('now');
			});
			if(now_ancher) {
				now_ancher.classList.add('now');
			}
		});


		// アンカーリンク閉じる（SP）
		document.querySelector('.nav').addEventListener('click', (event) => {
			if (mediaQuery.matches) {
				if(!event.target.closest('.nav-inner') && event.target !== lp_anchor_btn && lp_anchor.classList.contains("is-open")) {
					lp_anchor.classList.remove('is-open');
					lp_anchor_btn.classList.remove('is-open');
					nav_bg.classList.remove('is-open');
					bodyScrollLock.clearAllBodyScrollLocks();
				}
			}
		});

		// アンカーボタン位置終了（SP）
		let pageBottom =  document.querySelector('.PoliceLink__PoliceWrapper-sc-18ko1yx-0');
		let scene_03 = new ScrollMagic.Scene({
			triggerElement: pageBottom,// トリガー
			triggerHook: 'onEnter',// トリガーが見えたら
			reverse: true,// 逆スクロールに対応
			offset: 0 //
		})
		controller.addScene([
			scene_03
		]);
		// .addTo(controller);
		scene_03.on('progress', ()=>{
			if(!lp_anchor_btn.classList.contains("is-stop")) {
				lp_anchor_btn.classList.add('is-stop');// classを追加
			} else if(lp_anchor_btn.classList.contains("is-stop")) {
				lp_anchor_btn.classList.remove('is-stop');
			}
		})
	};
	window.addEventListener('DOMContentLoaded', () => {
		commonAction();
	})
	setTimeout(function() {
		commonAction();
	}, 500);
})();